import { Context } from './aggregates';
import { AuthenticationAggregate } from './aggregates/authentication';
import { FluxType } from './flux/buildFlux';
import { Services } from './services';
import { AppServices } from './services/Service';
import { Observable } from 'rxjs';

export default function CordovaServices(
  flux: FluxType,
  authenticationAggregate: AuthenticationAggregate,
  aggregates$: Observable<Context>): AppServices {
  console.log('deviceready');

  const services = new Services(authenticationAggregate.queries.authInfo$, flux, aggregates$);
  return services.build();
}
